'use client';

import { useState } from 'react';
import Image from 'next/image';

import { Typography } from 'lighthouse';

import { AllServicesModal } from './_components/AllServicesModal';
import { ServiceItem } from './_components/ServiceItem';
import { ServiceTilesProps } from './models';

export const ServiceTiles = ({ contentData }: ServiceTilesProps) => {
    const [isServicesModalOpen, setIsServicesModalOpen] = useState(false);

    const visibleServices = contentData.content.slice(0, 9);
    const hasMoreServices = contentData.content.length > 9;
    const gridServicesCount = visibleServices.length + (hasMoreServices ? 1 : 0);

    const lastRowStartClassNames: Record<number, string> = {
        1: 'col-start-5',
        2: 'col-start-4',
        3: 'col-start-3',
        4: 'col-start-2'
    };

    const getGridItemClassName = (index: number, itemsCount: number) => {
        const lastRowItemsCount = itemsCount % 5;
        const firstLastRowIndex = lastRowItemsCount === 0 ? -1 : itemsCount - lastRowItemsCount;

        return `col-span-2 ${index === firstLastRowIndex ? lastRowStartClassNames[lastRowItemsCount] : ''}`;
    };

    return (
        <>
            <div className='grid w-full grid-cols-10 gap-x-2 gap-y-4 py-8 md:gap-x-4 md:py-12'>
                {visibleServices.map((service, index) => (
                    <div key={service.id} className={getGridItemClassName(index, gridServicesCount)}>
                        <ServiceItem service={service} />
                    </div>
                ))}
                {hasMoreServices && (
                    <div className={getGridItemClassName(visibleServices.length, gridServicesCount)}>
                        <button
                            type='button'
                            className='block w-full cursor-pointer border-0 bg-transparent p-0 text-inherit'
                            onClick={() => setIsServicesModalOpen(true)}>
                            <div
                                className='flex h-full flex-col items-center justify-center rounded-lg border border-N200 bg-white p-3
                                    shadow-elevation1 transition-all duration-300 hover:-translate-y-1 hover:border-primary/30
                                    hover:shadow-elevation2'>
                                <div className='flex h-12 w-12 items-center justify-center rounded-lg bg-gradient-to-br from-primary/10 to-sky-100'>
                                    <Image src='/images/serviceTiles/more.svg' alt='more' width={36} height={36} />
                                </div>
                                <Typography
                                    variant='caption'
                                    component='span'
                                    className='mt-2 text-center text-[10px] font-bold text-blackHighEmphasis md:text-xs'>
                                    بیشتر
                                </Typography>
                            </div>
                        </button>
                    </div>
                )}
            </div>
            <AllServicesModal open={isServicesModalOpen} onClose={() => setIsServicesModalOpen(false)} services={contentData.content} />
        </>
    );
};
